import { createFileRoute, notFound } from "@tanstack/react-router";
import commissionsStyles from "../styles/commissions.css?url";
import { CommissionServicePage } from "../components/commissions/commission-service";
import { useShell } from "../lib/document-route";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { usePublishedData } from "../lib/published-data";
import { loadCommissionService } from "../server/commissions";

/**
 * One commission service (/commissions/:slug): what it is, its terms, and its request form. A
 * prepared website serves it as every visitor's page; a signed-in visitor's name and email for
 * the form arrive afterwards from the site's private page read.
 */
export const Route = createFileRoute("/commissions/$slug")({
  loader: async ({ params }) => {
    const data = await loadCommissionService({ data: params.slug });
    if (!data) throw notFound();
    return data;
  },
  // The form carries a signed-in viewer's name, so nothing keeps it once they leave.
  staleTime: 0,
  gcTime: 0,
  head: ({ matches, loaderData, match }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const { service } = loaderData;
    const head = creatorPageHead(shell, {
      pathname: match.pathname,
      title: `${service.title} | ${shell.creator.name}`,
      description:
        service.description.slice(0, 300) ||
        `Commission ${service.title} from ${shell.creator.name}.`,
      noindex: service.status === "unlisted",
      image: service.images[0],
    });
    return withStylesheet(head, commissionsStyles);
  },
  component: Service,
});

function Service() {
  const shell = useShell();
  const { slug } = Route.useParams();
  const { data } = usePublishedData(Route.useLoaderData(), shell, `/commissions/${slug}`, "page");
  return <CommissionServicePage key={data.service.id} data={data} />;
}
